import { get, paramsToUrl } from '@/utils'

// Store active controllers by endpoint
const activeControllers = new Map();

const remoteValidation = async (value, endpoint) => {
  let result = { errorMessage: "", data: null };
  if (!value) return result;

  // Abort any existing request for this endpoint
  if (activeControllers.has(endpoint)) {
    console.log(`Aborting previous request for endpoint: ${endpoint}`);
    activeControllers.get(endpoint).abort();
  }

  // Create new controller for this request
  const controller = new AbortController();
  activeControllers.set(endpoint, controller);


  try {
    let parameters = { value };
    let url = paramsToUrl(endpoint, parameters);

    const response = await get(url, {
      signal: controller.signal  // Pass the abort signal as a fetch option
    }, {
      showLoading: false
    });

    if (!response.ErrorCode) {
      result.errorMessage = undefined;
    } else {
      result.errorMessage = response.Data?.ErrorText ? response.Data.ErrorText : 'Validation failed with error code: ' + response.ErrorCode;
    }

    result.data = response?.Data ? response.Data : response;

  } catch (error) {
    // Don't treat AbortError as a validation error
    if (error.name === 'AbortError') {
      // Request was cancelled, return empty result
      return { errorMessage: "", data: null };
    }
    result.errorMessage = 'Failed to validate. Please try again. ' + error.message;
  } finally {
    // Clean up the controller after request completes
    activeControllers.delete(endpoint);
  }

  return result;
}

export { remoteValidation };